// removed by extract-text-webpack-plugin
module.exports = {"picture":"_1lr_"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/Slider/Slider.scss
// module id = aiRw
// module chunks = 0